import { useState } from "react";
import { api, formatApiErrorDetail } from "../../lib/api";
import { useAuth } from "../../contexts/AuthContext";
import { toast } from "sonner";

export default function Account() {
  const { user, refresh } = useAuth();
  const [name, setName] = useState(user?.name || "");
  const [email, setEmail] = useState(user?.email || "");
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const sensitiveChanged =
    (email.trim() && email.trim().toLowerCase() !== (user?.email || "").toLowerCase()) ||
    newPassword.length > 0;

  const submit = async (e) => {
    e.preventDefault();
    if (newPassword && newPassword !== confirmPassword) {
      return toast.error("New passwords don't match.");
    }
    if (sensitiveChanged && !currentPassword) {
      return toast.error("Enter your current password to change email or password.");
    }
    setBusy(true);
    try {
      await api.patch("/admin/me", {
        name: name.trim(),
        email: email.trim() !== user?.email ? email.trim() : undefined,
        current_password: sensitiveChanged ? currentPassword : undefined,
        new_password: newPassword || undefined,
      });
      toast.success("Account updated");
      setCurrentPassword("");
      setNewPassword("");
      setConfirmPassword("");
      if (refresh) await refresh();
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="p-8 max-w-xl" data-testid="account-page">
      <p className="btw-overline mb-1">Admin</p>
      <h1 className="text-2xl font-bold text-black mb-6">My account</h1>

      <form onSubmit={submit} className="bg-white border border-[#c19872] rounded-xl p-6 space-y-5" data-testid="account-form">
        <div>
          <label className="text-xs font-bold block mb-1">Name</label>
          <input data-testid="account-name" className="btw-input" value={name}
                 onChange={(e) => setName(e.target.value)} />
        </div>
        <div>
          <label className="text-xs font-bold block mb-1">Email</label>
          <input data-testid="account-email" type="email" className="btw-input" value={email}
                 onChange={(e) => setEmail(e.target.value)} />
        </div>
        <div className="pt-2 border-t border-[#dcd3c6]">
          <p className="text-xs font-bold mb-3">Change password</p>
          <label className="text-xs block mb-1">New password (min 8 characters)</label>
          <input data-testid="account-new-password" type="password" className="btw-input mb-4"
                 value={newPassword} onChange={(e) => setNewPassword(e.target.value)} />
          <label className="text-xs block mb-1">Confirm new password</label>
          <input data-testid="account-confirm-password" type="password" className="btw-input"
                 value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} />
        </div>
        {sensitiveChanged && (
          <div className="pt-2 border-t border-[#dcd3c6]" data-testid="current-password-block">
            <label className="text-xs font-bold block mb-1">Current password (required to change email or password)</label>
            <input data-testid="account-current-password" type="password" className="btw-input"
                   value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)} />
          </div>
        )}
        <button type="submit" disabled={busy} data-testid="account-save" className="btw-btn">
          {busy ? "Saving…" : "Save changes"}
        </button>
      </form>
    </div>
  );
}
